module.exports = __webpack_public_path__ + "img/bosspack_cod_dg.fff48770.png";